const getSecaoCnaeFilterFields = () => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'descricao',
    label: 'Descrição',
    initial: true,
  },
  {
    name: 'codigo',
    label: 'Código',
  },
];

export default getSecaoCnaeFilterFields;
